import Text from '@ingka/text';
import React from 'react';

export const CheckBoxLabel = ({ label, subLabel }: { label: string, subLabel: string }) => (
    <>
        <Text textStyle="Body.M">{label}</Text>
        <Text textStyle="Body.S">{subLabel}</Text>
    </>

);
